import ModalRemoveUser from './ModalRemoveUser'

export default ModalRemoveUser
// eslint-disable-next-line import/export
export * from './ModalRemoveUser'
